export default class NavigateHome {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.router.navigateHome();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/current_location/navigate_home.js